import { useState, useEffect } from 'react'
import WebService from '@util/webService'
import { useSelector, useDispatch } from 'react-redux'
import { setSchools } from '../redux/actions/schoolAction'
import { setCodes } from '../redux/actions/codeAction'

const checkInterval = 60000
const fetchSchools = async () => {
  const url = '/school'
  const resp = await WebService.get(url)

  if (resp.repCode === 'ack') {
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    records.forEach(r => {
      r.label = `${r.name}(${r.newZipCode}, ${r.newAddr1})`
    })
    return records
  }
}

const fetchCodes = async () => {
  const url = '/code'
  const resp = await WebService.get(url)

  if (resp.repCode === 'ack') {
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    return records
  }
}


const useDataVersionSync = () => {
  // const [versions, set_versions] = useState({ schoolVersion: 0, codeVersion: 0 })
  const dispatch = useDispatch()
  const existingSchools = useSelector(state => state.schoolReducer)
  const existingCodes = useSelector(state => state.codeReducer)
  const account = useSelector(state => state.accountReducer)

  // console.log('existingSchools=>', existingSchools)
  const checkDataVersion = async () => {

    if (!account?.user?.id) return
    console.log('check data version...')

    const now = Date.now()
    const lastCheck = parseInt(localStorage.getItem('lastDataVersionCheck') || '0')
    const gap = now - lastCheck

    if (gap < checkInterval) {
      return
    }

    // 중복 체크 방지
    localStorage.setItem('lastDataVersionCheck', now.toString())


    try {
      // 아파치가 서빙하는 정적 파일 호출
      const response = await fetch('/dataVersion.json', { cache: 'no-store' })
      const newVersions = await response.json()

      // 기존 로컬 스토리지에 저장된 버전과 비교
      const localSchoolVersion = localStorage.getItem('schoolVersion') || 0
      const localCodeVersion = localStorage.getItem('codeVersion') || 0

      // 학교 정보
      if (newVersions.schoolVersion > localSchoolVersion || !existingSchools || existingSchools.length === 0) {
        console.log('코드 정보 업데이트 감지')
        const records = await fetchSchools()
        if (records) {
          localStorage.setItem('schoolVersion', newVersions.schoolVersion)
          dispatch(setSchools(records))
        }

      }

      // 코드 정보
      if (newVersions.codeVersion > localCodeVersion || !existingCodes || existingCodes.length === 0) {
        console.log('코드 정보 업데이트 감지')
        const records = await fetchCodes()
        if (records) {
          localStorage.setItem('codeVersion', newVersions.codeVersion)
          dispatch(setCodes(records))
        }
      }

      // set_versions(newVersions)
    }
    catch (error) {
      console.error('버전 체크 중 오류 발생:', error)
    }
  }

  useEffect(() => {
    checkDataVersion()

    const timer = setInterval(checkDataVersion, checkInterval)
    return () => clearInterval(timer)
  }, [account?.user?.id])

  return null
}

export default useDataVersionSync